import { Box, Container, Typography } from '@mui/material/';
import React from 'react';
import { CloseErrorDialog } from './CloseErrorDialog';
import { CompanyOfficeForm } from './CompanyOfficeForm';
import { ReportTerm } from './ReportTerm';
import { Result } from './Result';
import { ServiceAndUploadCsv } from './ServiceAndUploadCsv';
import { SnackbarMessage } from './SnackbarMessage';
import { useForm } from '../hooks/useForm';
import { useSnackbarMessage } from '../hooks/useSnackbarMessage';

const Form = () => {
  const {
    companyName,
    companyNo,
    officeNo,
    setCompanyName,
    setCompanyNo,
    setOfficeNo,
    setService,
    setServiceCost,
    setUploadFileSe,
    setUploadFileSv,
    service,
    serviceCost,
    uploadFileSe,
    uploadFileSv,
  } = useForm();

  const { onClose, snackbarMessage, setSnackbarMessage } = useSnackbarMessage();

  return (
    <Container maxWidth="lg" className="pt-4">
      <Box className="relative space-y-4 pb-4 text-center">
        <Box>
          <Typography variant="h3">売上レポート</Typography>
        </Box>
        <Box className="absolute right-0 top-0 rounded-lg bg-red-500 px-4 text-sm text-white">
          <a href="https://anispi.co.jp/rsry-report-guide/" target="_blank" rel="noreferrer">
            使い方
          </a>
        </Box>
        <Box>
          <p>当月の国保連請求等からレベニューシェア及びロイヤリティーを自動計算します。</p>
        </Box>

        <ReportTerm />
      </Box>

      <Box className="space-y-4 pb-4">
        <CompanyOfficeForm
          companyName={companyName}
          companyNo={companyNo}
          officeNo={officeNo}
          setCompanyName={setCompanyName}
          setCompanyNo={setCompanyNo}
          setOfficeNo={setOfficeNo}
        />

        <ServiceAndUploadCsv
          companyName={companyName}
          companyNo={companyNo}
          officeNo={officeNo}
          service={service}
          setService={setService}
          setServiceCost={setServiceCost}
          setUploadFileSe={setUploadFileSe}
          setUploadFileSv={setUploadFileSv}
          uploadFileSe={uploadFileSe}
          uploadFileSv={uploadFileSv}
        />

        {service && (
          <Result
            companyName={companyName}
            companyNo={companyNo}
            officeNo={officeNo}
            service={service}
            serviceCost={serviceCost}
            setService={setService}
            setServiceCost={setServiceCost}
            setSnackbarMessage={setSnackbarMessage}
            setUploadFileSe={setUploadFileSe}
            setUploadFileSv={setUploadFileSv}
            uploadFileSe={uploadFileSe}
            uploadFileSv={uploadFileSv}
          />
        )}
      </Box>
      <CloseErrorDialog />
      <SnackbarMessage
        open={snackbarMessage.open}
        severity={snackbarMessage.severity}
        message={snackbarMessage.message}
        onClose={onClose}
      />
    </Container>
  );
};

export { Form };
